<template>
  <div class="fun-right-wrap">
    <div
      v-show="!headerUserRest.orderId"
      :class="NoCopyright ? 'noOrderId' : 'noOrderId_NoCopyright'"
    ></div>
    <div v-show="headerUserRest.orderId">
      <div class="right-header-info">
        <div class="name-wrap">
          <p class="patientName">{{ headerUserRest.patientName }}</p>
          <p class="cardId">{{ headerUserRest.cardId }}</p>
          <!-- <p class="status">待接诊</p> -->
          <p class="status" :class="'status' + headerUserRest.status">
            {{ headerUserRest.statusText }}
          </p>
        </div>
        <div class="info-wp">
          <p>
            <span>性别：</span><strong>{{ headerUserRest.sex }}</strong>
            <span>年龄：</span><strong>{{ headerUserRest.age }}</strong>
            <span>问诊方式：</span>
            <strong v-if="headerUserRest.inquiryType === 0">图文问诊</strong>
            <strong v-if="headerUserRest.inquiryType === 1">电话问诊</strong>
            <strong v-if="headerUserRest.inquiryType === 2">视频问诊</strong>
            <span>联系方式：</span
            ><strong>{{ headerUserRest.patientMobile }}{{/*精准时间*/}}</strong>
          </p>
          <p>
            <!-- <span>挂号时间：</span><strong>{{headerUserRest.time}}</strong> -->
            <span>预约时间：</span
            ><strong
              >{{ headerUserRest.time }}{{ headerUserRest.timeSlot }}</strong
            >
          </p>
        </div>
        <!-- <div class="info-a">
          <div>性别：{{headerUserRest.sex}}&nbsp;&nbsp;&nbsp;年龄：{{headerUserRest.age}}</div>
          <div>预约时间：{{headerUserRest.time}}</div>
        </div>
        <div class="info-b">
          <div>联系方式：{{headerUserRest.patientMobile}}</div>
          <div>时间段：{{headerUserRest.timeSlot}}</div>
        </div>
        <div class="info-c">
          <div>就诊卡号：{{headerUserRest.cardId}}</div>
          <div>
            问诊方式：
            <span
              v-if="headerUserRest.inquiryType === 0 "
            >图文问诊</span>
            <span v-if="headerUserRest.inquiryType === 1 ">电话问诊</span>
            <span v-if="headerUserRest.inquiryType === 2 ">视频问诊</span>
          </div>
        </div> -->
        <div class="fun-wrap">
          <div
            v-if="headerUserRest.status <= 3 && headerUserRest.status >= 1"
            class="reception-btn"
          >
            <span
              class="blue-btn"
              @click="completion(1)"
              v-if="headerUserRest.status === 1"
              >接诊</span
            >
            <span
              class="red-btn"
              @click="refuse"
              v-if="headerUserRest.status === 1"
              >拒接诊</span
            >
            <span
              class="red-btn"
              @click="completion(2)"
              v-if="headerUserRest.status === 2"
              >结诊</span
            >
            <span class="gray-btn" v-if="headerUserRest.status === 3"
              >结诊</span
            >
            <!-- <Button class="btn-style" type="info"  @click="completion(1)" v-if=" headerUserRest.status === 1">接诊</Button>
            <Button class="btn-style" type="error" @click="completion(2)"  v-if=" headerUserRest.status === 2">结诊</Button>-->
          </div>
          <!-- <div class="reception-btn">
                接诊
          </div>-->
        </div>
      </div>
      <div
        :class="
          NoCopyright ? 'right-content-info' : 'right-content-info_NoCopyright'
        "
      >
        <div class="tool-box" v-show="showTooBox">
          <div class="im-box im-box-communication">
            <img
              v-if="headerUserRest.orderId"
              src="../../../assets/images/liaotian.png"
              alt="沟通"
              @click="showIm"
            />
            <img
              v-else
              src="../../../assets/images/liaotian_.png"
              alt="沟通"
              @click="showIm"
            />
          </div>

          <div class="im-box im-box-audio">
            <img
              v-if="
                headerUserRest.status !== 2 ||
                headerUserRest.inquiryType == 2 ||
                headerUserRest.inquiryType == 0 ||
                showSaveModal
              "
              src="../../../assets/images/dianhua_.png"
              alt="音频"
            />
            <img
              v-if="
                headerUserRest.status === 2 &&
                headerUserRest.inquiryType == 1 &&
                !showSaveModal
              "
              src="../../../assets/images/dianhua.png"
              alt="音频"
              @click="phoneCall"
            />
          </div>

          <div class="im-box im-box-video">
            <img
              v-if="
                headerUserRest.status !== 2 ||
                headerUserRest.inquiryType == 1 ||
                headerUserRest.inquiryType == 0 ||
                showSaveModal
              "
              src="../../../assets/images/shipin_.png"
              alt="视频"
            />
            <img
              v-if="
                headerUserRest.status === 2 &&
                headerUserRest.inquiryType == 2 &&
                !showSaveModal
              "
              src="../../../assets/images/shipin.png"
              alt="视频"
              @click="videoCall"
            />
          </div>

          <div class="im-box im-box-video">
            <img
              v-if="headerUserRest.status === 3"
              src="../../../assets/images/register_.png"
              alt="诊间转约"
            />
            <img
              v-if="headerUserRest.status !== 3"
              src="../../../assets/images/register.png"
              alt="诊间转约"
              @click="handlerRegistration"
            />
          </div>

          <div class="im-box im-box-video">
            <img
              v-if="reportlength <= 0"
              src="../../../assets/images/report_.png"
              alt="查看报告"
            />
            <img
              v-if="reportlength > 0"
              src="../../../assets/images/report.png"
              alt="查看报告"
              @click="handlerReport"
            />
          </div>
          <div class="im-box im-box-video">
            <img
              v-if="caseInfoHistorylength <= 0"
              src="../../../assets/images/report_.png"
              alt="历史病历"
              title="历史病历"
            />
            <img
              v-if="caseInfoHistorylength > 0"
              src="../../../assets/images/report.png"
              alt="历史病历"
              title="历史病历"
              @click="handlerCaseInfoHistory"
            />
          </div>
        </div>
        <div
          :class="
            showTooBox ? 'tool-box-put' : 'tool-box-put tool-box-put-right'
          "
          @click="showTooBox = !showTooBox"
        >
          <Icon type="ios-arrow-forward" v-show="showTooBox" />
          <Icon type="ios-arrow-back" v-show="!showTooBox" />
          功能
        </div>

        <div class="tab-wrap">
          <div class="tab-tag" @click="changeTab">
            <div
              v-for="(item, index) in tabColumns"
              :key="index"
              :data-key="item.key"
              :class="{
                'checked-tab': item.key == checkedTagKey,
                'ban-btn': checkedTagType == 1 && item.key !== 1,
              }"
            >
              {{ item.value }}
            </div>
          </div>
          <div class="tab-content">
            <reservation-info v-show="checkedTagKey == 1"></reservation-info>
            <illness-history v-show="checkedTagKey == 2"></illness-history>
            <prescription-page v-show="checkedTagKey == 3"></prescription-page>
            <check-up-page v-show="checkedTagKey == 4"></check-up-page>
            <check-out-page v-show="checkedTagKey == 5"></check-out-page>
          </div>
        </div>
        <!-- <div id="side-box" :class="sideBoxStatus?'side-box open-style':'side-box close-style'">
          <div id="draw-tag" class="draw-tag" @click="openSideBox"></div>
        </div> -->
        <!-- im组件 -->
        <im-page
          :showIMStore="showIMStore"
          :messgeRegistration="imMessge.messgeRegistration"
          :isSend="imMessge.isSend"
        ></im-page>
      </div>
      <breadcrumb></breadcrumb>
    </div>

    <Modal
      :draggable="draggable"
      :mask-closable="false"
      :fullscreen="fullscreen"
      :closable="false"
      v-model="showSaveModal"
      class="imModal"
      title="音视频"
    >
      <div class="videoContainerWrap">
        <div
          id="remoteContainer"
          class="videoContainer"
          autoplay="autoplay"
          width="300px"
          height="500px"
        ></div>
        <div
          id="localContainer"
          class="videoContainer"
          autoplay="autoplay"
          width="300px"
          height="500px"
        ></div>
      </div>
      <div class="zoom-btn" @click="zoomContract">
        <Icon type="ios-contract" />
      </div>
      <div slot="footer">
        <Button type="error" size="large" long @click="hangup">挂断</Button>
      </div>
    </Modal>

    <Modal
      v-model="jiezhenModal"
      title="结诊确认"
      @on-ok="jiezhenOk"
      @on-cancel="jiezhenCancel"
    >
      <p>{{ jiezhenCause.msg }}</p>
    </Modal>
    <changeRegistration
      :parameter="isRegistrationModel"
      v-on:handlerMessage="handlerMessage"
      v-on:handlermodalCancel="handlerRegistrationCancel"
    >
    </changeRegistration>

    <clinicReport
      :parameter="isReportModel"
      v-on:handlermodalCancel="handlerReportModelCancel"
      v-on:reportLengthFunc="reportLengthFunc"
    ></clinicReport>
    <caseInfoHistory
      :parameter="isCaseInfoHistoryModel"
      v-on:handlermodalCancel="handlerCaseInfoHistoryModelCancel"
      v-on:reportLengthFunc="historyLengthFunc"
    ></caseInfoHistory>
    <!-- 拒接诊弹窗 -->
    <Modal
      v-model="refuseReasonShow"
      :closable="false"
      :mask-closable="false"
      title="拒绝接诊原因"
    >
      <Input
        v-model="refuseReason"
        type="textarea"
        style="width: 100%"
        placeholder="请输入拒绝接诊原因"
      />
      <div slot="footer">
        <Button @click="refuseqx">取消</Button>
        <Button type="primary" @click="refuseqd">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>

import { api } from '@/services'
import config from '@/config'
import { mapGetters, mapActions } from 'vuex'
import { EventBus } from '@/utils/tool'
import reservationInfo from './reservation_info/index' // 预约信息页
import illnessHistory from './illness_history/index' // 病历页
import prescriptionPage from './prescription_page/index' // 处方页
import checkUpPage from './check_up_page/index' // 检查页
import checkOutPage from './check_out_page/index' // 检验页
import breadcrumb from './breadcrumb/index' // 面包屑导航
import changeRegistration from './changeRegistration/index' // 诊间转约
import clinicReport from './clinicReport/index' //  查看报告
import caseInfoHistory from './caseInfoHistory/index' //  历史病历
import imPage from './im_page/index'

var NIM
var RTC
var RTC2
NIM = require('@/im/nim').default
RTC = require('@/im/').default
var NIM2 = require('@/im/nim_v2.js').default
export default {
  components: {
    reservationInfo,
    illnessHistory,
    prescriptionPage,
    checkUpPage,
    checkOutPage,
    breadcrumb,
    imPage,
    changeRegistration,
    clinicReport,
    caseInfoHistory
  },
  data () {
    return {
      refuseReasonShow: false,
      refuseReason: '',

      showTooBox: true,
      // 显示报告查看
      isReportModel: false,
      isCaseInfoHistoryModel:false,
      imMessge: {
        isSend: true,
        messgeRegistration: ''
      },
      tepYxVersion: '',
      reportlength: 0,
      caseInfoHistorylength:0,
      // 显示诊间转约
      isRegistrationModel: false,
      jiezhenModal: false,
      jiezhenCause: {
        status: 1,
        msg: '视频/电话未呼叫'
      },
      // 对话框 弹层
      // showSaveModal: false,
      fullscreen: false,
      draggable:true,
      tabColumns: [
        {
          checked: true,
          value: '预约信息',
          key: 1
        },
        {
          checked: false,
          value: '病历',
          key: 2
        },
        {
          checked: false,
          value: '处方',
          key: 3
        },
        {
          checked: false,
          value: '检查',
          key: 4
        },
        {
          checked: false,
          value: '检验',
          key: 5
        }
      ],
      // checkedTagKey: 1, // 选择标签的key
      // 侧边栏展开关闭状态
      sideBoxStatus: false,
      netcall: {},
      showIMTime: {},
      timerObj: {},
      timerId: 1,
      NoCopyright: config.NoCopyright
    }
  },
  computed: {
    ...mapGetters({
      headerUserRest: 'prvateConsultation/headerUserRest',
      showIMStore: 'prvateConsultation/showIM',
      // showIMTime: 'prvateConsultation/showIMTime',
      checkedTagKey: 'prvateConsultation/checkedTagKey',
      checkedTagType: 'prvateConsultation/checkedTagType',
      isDiagnosis: 'prvateConsultation/isDiagnosis',
      pagination: 'prvateConsultation/pagination',
      userInfo: 'auth/info',
      showSaveModal: 'prvateConsultation/showSaveModal',
      imOnConnect: 'prvateConsultation/imOnConnect'
    }),
    orderId (val) {
      return this.$store.state.prvateConsultation.orderId
    }
  },
  created: function () {

  },
  watch: {

    orderId: function (val) {
      clearInterval(this.$store.state.prvateConsultation.intervalID)
      clearInterval(this.showIMTime)
      this.timerObj = {}
      this.$store.commit('prvateConsultation/showImBox', false)
    },
    headerUserRest (key) {
      if (!key) {
        this.$store.commit('prvateConsultation/setHeaderUserRest', {})
      }
    },
    showIMStore: function () {
      let that = this
      clearInterval(that.showIMTime)
      // debugger
      // that.showIMTime = setInterval(function () {
      if (that.showIMStore) {
        that.handlerGetOfflineMsg()
      } else {
        that.timerObj = {}
        return false
      }
      // }, 2500)
    }
  },
  methods: {
    ...mapActions({
      fetchOnlineDiagnoseList: 'prvateConsultation/fetchOnlineDiagnoseList'
    }),

    // 拒接取消
    refuseqx () {
      this.refuseReasonShow = false
      this.refuseReason = ''
    },
    // 拒接确定
    refuseqd () {
      if (!this.refuseReason) {
        this.$Message.warning('请输入拒绝接诊原因')
        return false
      }
      api
        .refuseConsultation({
          data: {
            params: {
              orderId: this.$store.state.prvateConsultation.orderId,
              refuseReason: this.refuseReason
            }
          }
        })
        .then(res => {
          this.refuseReason = ''
          this.refuseReasonShow = false
          if (res.code == '0') {
            this.fetchOnlineDiagnoseList(this.pagination)
          }
        })
    },
    // 拒接诊
    refuse () {
      this.refuseReasonShow = true
    },
    // 关闭查看报告的弹窗
    handlerReportModelCancel () {
      this.isReportModel = false
    },
    // 关闭历史病历的弹窗
    handlerCaseInfoHistoryModelCancel () {
      this.isCaseInfoHistoryModel = false
    },
    handlerMessage (imMessgep) {
      this.imMessge.isSend = true
      this.imMessge.messgeRegistration = imMessgep
    },
    // 查看报告
    handlerReport () {
      this.isReportModel = true
    },
    handlerCaseInfoHistory () {
      this.isCaseInfoHistoryModel = true
    },
    reportLengthFunc (reportlength) {
      this.reportlength = reportlength
    },
    historyLengthFunc (historylength) {
      this.caseInfoHistorylength = historylength
    },
    handlerRegistration () {
      this.isRegistrationModel = true
    },
    handlerRegistrationCancel () {
      this.isRegistrationModel = false
    },

    jiezhenOk () {
      if (this.jiezhenCause.status == 1) {
        this.videoCall()
      } else if (this.jiezhenCause.status == 2) {
        this.phoneCall()
      }
    },
    jiezhenCancel () {
      this.jiezhenModal = false
    },
    handlerGetOfflineMsg () {
      let that = this
      const id = this.timerId++
      this.timerObj[id] = true

      async function getMsg () {
        if (!that.timerObj[id]) return
        let userId = that.userInfo.userId
        let doctorIM = []
        let itemkey = userId + '&taogu&' + that.headerUserRest.xbkp_user
        await api.getArchiveMsg({
          data: {
            params: {
              // 时间戳
              time: new Date().getTime(),
              history: 0,
              toUserType: 2
            }
          }

        })
          .then(res => {
            console.log(res)
            for (const key in res) {
              if (typeof res[key] === 'object') {
                if (JSON.parse(localStorage.getItem(itemkey)) != null) {
                  doctorIM = JSON.parse(localStorage.getItem(itemkey))
                }

                doctorIM.push(res[key])
                localStorage.setItem(itemkey, JSON.stringify(doctorIM))
              }
            }
          })

        // setTimeout(() => {
        //   // getMsg()
        // }, 2500)
      }
      // getMsg()
    },
    hangup () {
      if (this.tepYxVersion === '1.0') {
        RTC.hangup(this.netcall)
      } else {
        RTC2.hangup()
      }

      // this.showSaveModal = false
      this.$store.commit('prvateConsultation/setShowSaveModal', false)
    },
    zoomContract () {
      this.fullscreen = !this.fullscreen
      this.draggable = !this.fullscreen
    },
    videoCall () {
      api
        .videoCallMo({
          data: {
            params: {
              xbid: this.headerUserRest.xbkp_user,
              order_id: this.headerUserRest.orderId
            }
          }
        })
        .then(res => {
          if (res.code == '0') {
            try {
              this.tepYxVersion = res.data.mt_account.yxVersion
              if (this.tepYxVersion == '1.0') {
                var nim = NIM.imInit(
                  res.data.mo_account.token,
                  res.data.appKey,
                  res.data.mo_account.accid
                )

                let _this = this
                let timeImOnConnect = setInterval(function () {
                  console.log('我是imOnConnect', _this.imOnConnect)
                  if (_this.imOnConnect) {
                    _this.netcall = RTC.webRTC(nim, res.data.mt_account.accid, 'video')
                    clearInterval(timeImOnConnect)
                  }
                }, 1000)
              } else {
                // 音视频2.0
                if (!RTC2) {
                  RTC2 = NIM2.imInit(
                    res.data.mo_account.token,
                    res.data.appKey,
                    res.data.mo_account.accid
                  )
                }
                setTimeout(() => {
                  RTC2.call({
                    userId: res.data.mt_account.accid, // 对方的userId
                    type: 2 // 1 音频；2 视频
                  })
                }, 3000)
              }

              // this.showSaveModal = true
              this.$store.commit('prvateConsultation/setShowSaveModal', true)
            } catch (e) {
              console.log('视频异常', e)
              this.$Message.error('当前浏览器不支持视频通话')
            }
          }
        })
    },
    phoneCall () {
      api
        .videoCallMo({
          data: {
            params: {
              xbid: this.headerUserRest.xbkp_user,
              order_id: this.headerUserRest.orderId
            }
          }
        })
        .then(res => {
          if (res.code == '0') {
            try {
              this.tepYxVersion = res.data.mt_account.yxVersion
              if (this.tepYxVersion == '1.0') {
                var nim = NIM.imInit(
                  res.data.mo_account.token,
                  res.data.appKey,
                  res.data.mo_account.accid
                )
                let _this = this
                // 没有找到更好的办法   暂时hack定时任务
                let timeImOnConnect = setInterval(function () {
                  if (_this.imOnConnect) {
                    _this.netcall = RTC.webRTC(nim, res.data.mt_account.accid, 'audio')
                    clearInterval(timeImOnConnect)
                  }
                }, 1000)
              } else {
                // 音视频2.0
                if (!RTC2) {
                  RTC2 = NIM2.imInit(
                    res.data.mo_account.token,
                    res.data.appKey,
                    res.data.mo_account.accid
                  )
                }
                setTimeout(() => {
                  RTC2.call({
                    userId: res.data.mt_account.accid, // 对方的userId
                    type: 1 // 1 音频；2 视频
                  })
                }, 3000)
              }

              // this.showSaveModal = true
              this.$store.commit('prvateConsultation/setShowSaveModal', true)
            } catch (e) {
              this.$Message.error('当前浏览器不支持视频通话')
            }
          }
        })
    },

    // CA自动签
    // doctorCertAutoSign (id) {
    //   api.doctorCertAutoSign({
    //     data: {
    //       params: {
    //         caUserId: id
    //       }
    //     }
    //   })
    // },

    changeTab (e) {
      if (this.checkedTagType == 1) {
        return false
      }
      let key = e.target.dataset.key
      if ((key === '3' || key === '4' || key === '5') && this.isDiagnosis !== 0) {
        if (this.isDiagnosis === 2) {
          api.adminOnlineCaseItem({
            data: {
              params: {
                orderId: this.$store.state.prvateConsultation.orderId
              }
            }
          }).then(res => {
            if (res.code === 0) {
              this.$store.commit('prvateConsultation/setIsDiagnosis', res.data.status)
              if (res.data.status === 2) {
                this.$Modal.warning({
                  content: '请先完成诊断和ca签名'
                })
              }
            }
          })
        } else {
          this.$Modal.warning({
            content: '请先完成诊断'
          })
        }

        return false
      }
      this.tabColumns.map(item => {
        if (item.key == key) {
          item.checked = true
        } else {
          item.checked = false
        }
      })
      if (this.checkedTagType != 1) {
        this.$store.commit('prvateConsultation/setCheckedTagKey', key)
      }
      // 判断是否调用CA自动签
      // let caUserId = localStorage.getItem('TG_SERVER_TOKEN_caUserId')
      // if (caUserId) {
      //   this.doctorCertAutoSign(caUserId)
      // }
      // this.checkedTagKey = key
    },
    completion (status) {
      // return false
      if (this.$store.state.prvateConsultation.orderId != '') {
        api
          .adminDiagnoseSatus({
            data: {
              params: {
                orderId: this.$store.state.prvateConsultation.orderId,
                option: status
              }
            }
          })
          .then(res => {
            if (res.code == '0') {
              // 病例未填写
              if (res.data.status == 0) {
                this.$Message.warning(res.data.msg)
                return false
              } else if (res.data.status == 1 || res.data.status == 2) {
                this.jiezhenModal = true
                this.jiezhenCause = res.data
                return false
              } else {
                this.$store.commit(
                  'prvateConsultation/setOrderStatus',
                  status + 1
                )
                EventBus.$emit('incremented', status + 1)
                this.fetchOnlineDiagnoseList(this.pagination)
              }
            }
          })
      } else {
        this.$Message.error('订单不存在')
      }
    },
    showIm () {
      this.$store.commit('prvateConsultation/showImBox', true)
    },
    // 展开关闭侧边栏
    openSideBox () {
      this.sideBoxStatus = !this.sideBoxStatus
    }
  }
}

</script>

<style lang="scss">
.fun-right-wrap {
  width: 100%;
  margin-right: 6px;
  flex-direction: column;
  justify-content: flex-start;
  overflow: hidden;
}
.noOrderId {
  width: 100%;
  height: 100%;
  background: url('~@/assets/images/init_bg_1.png') center / 300px no-repeat,
    url('~@/assets/images/init_bg_2.png') right bottom / 200px no-repeat;
}
.noOrderId_NoCopyright {
  width: 100%;
  height: 100%;
  background: url('~@/assets/images/init_bg_1.png') center / 300px no-repeat;
}
.right-header-info {
  /* width: 685px; */
  height: 65px;
  margin-bottom: 5px;
  padding: 0 27px 0 20px;
  box-sizing: border-box;
  display: flex;
  background: #fff;
  justify-content: space-between;
  box-shadow: 0px 1px 3px 0px rgba(170, 170, 170, 0.39);
  border-radius: 4px 4px 0px 0px;
}
.right-header-info .name-wrap {
  min-width: 70px;
  padding-top: 18px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #333;
  line-height: 24px;
  margin-right: 50px;
  white-space: nowrap;
  position: relative;
  text-align: center;
  .patientName {
    font-size: 19px;
    font-weight: 500;
  }
  .cardId {
    height: 10px;
    line-height: 10px;
    font-size: 8px;
  }
  .status {
    position: absolute;
    right: -33px;
    top: 14px;
    font-size: 0;
    width: 36px;
    height: 14px;
    line-height: 14px;
    color: rgba(237, 64, 20, 1);
    text-align: center;
    background-repeat: no-repeat;
    background-size: contain;
    &.status1 {
      background-image: url('~@/assets/images/status1.png');
    }
    &.status2 {
      background-image: url('~@/assets/images/status2.png');
    }
    &.status3 {
      background-image: url('~@/assets/images/status3.png');
    }
    &.status4 {
      background-image: url('~@/assets/images/status4.png');
    }
  }
}
.info-a,
.info-b,
.info-c {
  height: 65px;
  margin-right: 12px;
  padding: 27px 0 15px 0;
  box-sizing: border-box;
  font-size: 9px;
  line-height: 9px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.info-a {
  width: 110px;
}
.info-b {
  width: 120px;
}
.info-c {
  width: 140px;
  margin-right: 44px;
}
.info-wp {
  width: 850px;
  font-family: 'MicrosoftYaHei';
  font-size: 9px;
  line-height: 12px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  height: 65px;
  padding: 27px 0 15px 0;
  strong {
    margin-right: 10px;
    font-weight: normal;
    color: #333;
  }
}
.fun-wrap {
  height: 65px;
  padding: 28px 0 18px 0;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.fun-wrap .im-box {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  cursor: pointer;
}
.im-box > img {
  width: 100%;
}

.fun-wrap > u {
  cursor: pointer;
  font-size: 8px;
  font-weight: 500;
  color: rgba(114, 190, 255, 1);
  margin-right: 9px;
}
.fun-wrap .reception-btn {
  width: 3rem;
  height: 20px;
  border-radius: 3px;
  line-height: 20px;
  text-align: center;
  font-size: 9px;
  font-weight: 500;
  color: #fff;
  cursor: pointer;
  align-items: center;
  display: flex;
  justify-content: space-evenly;
}
.right-content-info {
  /* width: 756px; */
  height: calc(100vh - 140px);
  overflow: hidden;
  flex: auto;
  box-sizing: border-box;
  position: relative;
  border-radius: 0px 0px 4px 4px;
  background: #fff url('~@/assets/images/filigrane.png') right bottom no-repeat;
  background-size: 100%;
  box-shadow: 0 0.03125rem 0.09375rem 0 rgba(170, 170, 170, 0.39);
}
.right-content-info_NoCopyright {
  /* width: 756px; */
  height: calc(100vh - 140px);
  overflow: hidden;
  flex: auto;
  box-sizing: border-box;
  position: relative;
  border-radius: 0px 0px 4px 4px;
  background-size: 100%;
  background: #fff;
  box-shadow: 0 0.03125rem 0.09375rem 0 rgba(170, 170, 170, 0.39);
}
.tab-wrap {
  // height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.right-content-info .side-box {
  width: 195px;
  height: 100%;
  position: absolute;
  top: 12px;
  background: #fff;
}
.open-style {
  right: 0;
}
.close-style {
  right: -155px;
}
.draw-tag {
  width: 10px;
  height: 35px;
  position: absolute;
  left: -10px;
  top: 186px;
  background: #fff;
  background: url('../../../assets/images/pop.png') no-repeat center;
  background-size: 100% 100%;
  cursor: pointer;
}
.tab-wrap .tab-tag {
  // height: 29px;
  padding-top: 4px;
  display: flex;
  justify-content: flex-start;
  margin: 0 2px;
  align-items: center;
  box-sizing: border-box;
  border-bottom: 1px solid rgba(114, 190, 255, 1);
  color: #333333;
}
.tab-tag > div {
  flex: 1;
  display: inline-block;
  height: 25px;
  white-space: nowrap;
  line-height: 25px;
  text-align: center;
  font-size: 10px;
  font-weight: 500;
  color: #333333;
  cursor: pointer;
  box-sizing: border-box;
}
.tab-tag > .checked-tab {
  font-weight: 400;
  background: rgba(114, 190, 255, 1);
  border-radius: 4px 4px 0px 0px;
  color: #fff;
}
.tab-tag > .ban-btn {
  cursor: not-allowed;
  background: #eee;
}
.tab-content {
  padding: 20px;

  height: calc(100vh - 140px - 29px);
}
.imModal .ivu-modal-fullscreen{
  width: 100% !important;
}
.imModal .ivu-modal-fullscreen .ivu-modal-content{
  width: 100% !important;
}
.imModal .ivu-modal-fullscreen #remoteContainer video{
  height:100% !important;
}
.videoContainerWrap {
  position: relative;
  width: 100%;
  height: 100%;
}
.videoContainer {
  width: 100%;
  min-height: 5rem;
  height: 95%;

  border: 0.01rem solid #eee;
  display: inline-block;
}
.videoContainer > div {
  width: 100% !important;
  min-height: 5rem !important;
  height: 100% !important;
}
#localContainer {
  position: absolute;
  right: 0rem;
  bottom: 0rem;
  width: 30%;
  height: 30% !important;
  min-height: 30%;
}
#localContainer > div {
  width: 100% !important;
  min-height: 100% !important;
  height: 100% !important;
}

.zoom-btn {
  cursor: pointer;
  text-align: right;
  position: relative;
  bottom: 1px;
}
.blue-btn {
  background: rgba(114, 190, 255, 1);
  display: block;
  border-radius: 3px;
  padding: 0.04rem 0.3rem;
}
.red-btn {
  background: #f00;
  display: block;
  border-radius: 3px;
  padding: 0.04rem 0.3rem;
}
.gray-btn {
  background: #c4c4c4;
  display: block;
  border-radius: 3px;
}
.tool-box {
  width: 1.2rem;
  position: absolute;
  z-index: 9;
  background: #fff;
  padding: 0.1rem;
  right: 0;
}
.tool-box-put {
  position: absolute;
  z-index: 9;
  background: #72beff;
  padding: 0.1rem;
  right: 1.2rem;
  display: inline;
  width: 0.7rem;
  text-align: center;
  top: 11%;
  color: #fff;
  cursor: pointer;
}
.tool-box-put-right {
  right: 0;
}
.tool-box .im-box {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/private_consultation_page/fun_right/index.vue